import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-down-left-icon',
  templateUrl: './navigation-down-left.component.html'
})
export class NavigationDownLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
